import { FC, useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  RouteComponentProps,
  RouteProps,
  Switch,
} from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { userData } from 'pages/Login/selectors';

import { privateRoutes, publicRoutes, routes } from './routers';

type CustomRouteProps = RouteProps & {
  isPrivate: boolean;
};

const Navigations: FC = () => (
  <Router>
    <Switch>
      {publicRoutes.map(({ component: Component, ...route }, index) => (
        <CustomRoute {...route} key={index} isPrivate={false}>
          <Component />
        </CustomRoute>
      ))}
      {privateRoutes.map(({ component: Component, ...route }, index) => (
        <CustomRoute {...route} key={index} isPrivate>
          <Component />
        </CustomRoute>
      ))}
      <Redirect path="*" to={'/'} />
    </Switch>
    <ToastContainer position="top-center" autoClose={3000} />
  </Router>
);

const CustomRoute: FC<CustomRouteProps> = ({ children, isPrivate, ...rest }) => {
  const [isLoading] = useState<boolean>(false);
  const { accessToken } = useSelector(userData);

  const handleRender = useCallback(
    ({ location }: RouteComponentProps) => {
      if ((isPrivate && accessToken) || (!isPrivate && !accessToken)) {
        return children;
      }
      return (
        <Redirect
          to={{
            pathname: isPrivate ? routes.Login.path : '/',
            state: { from: location },
          }}
        />
      );
    },
    [children, isPrivate, accessToken]
  );

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return <Route {...rest} render={handleRender} />;
};

export default Navigations;
